import { render, staticRenderFns } from "./DashboardStatistic.vue?vue&type=template&id=189e8f2e&"
import script from "./DashboardStatistic.vue?vue&type=script&lang=js&"
export * from "./DashboardStatistic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/proyectos/rosalinda-store/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VCardText})
